module.exports = {
      id: "price-marketing-mix-curacao-usage",
      viewBox: "0 0 47.8 47.8",
      url: __webpack_public_path__ + "img/symbols.b783b922d187f028e7dcd3736258c276.svg#price-marketing-mix-curacao",
      toString: function () {
        return this.url;
      }
    }